import { render, staticRenderFns } from "./AccountDiameterGroups.vue?vue&type=template&id=2200db61&"
import script from "./AccountDiameterGroups.vue?vue&type=script&lang=js&"
export * from "./AccountDiameterGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports